export const name = 'urlService' as const
